import { Component, OnInit, ViewEncapsulation, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { lastValueFrom, map } from 'rxjs';
import { PageableFilter, PageableRequest } from 'src/app/admin-api';
import { PageContent, TableColumn } from 'src/app/components/table';
import { AppDialogService } from 'src/app/services/dialog.service';
import { LoaderService } from 'src/app/services/loader.service';
import {
  MarketingGlampointsCreditRow,
  MarketingGlampointsService
} from 'src/app/services/marketing-glampoints.service';

@Component({
  selector: 'app-glampoints-action-history',
  templateUrl: './glampoints-action-history.component.html',
  styleUrl: './glampoints-action-history.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class GlampointsActionHistoryComponent implements OnInit {
  readonly marketingService = inject(MarketingGlampointsService);
  private title = inject(Title);
  private route = inject(ActivatedRoute);

  actionId?: number;
  actionName = '';
  fixedFilters: PageableFilter[] = [];

  cols: TableColumn[] = [
    new TableColumn.Builder()
      .setHeader('Data')
      .setField('createdAt')
      .setType('date')
      .setCondition('between')
      .build(),
    new TableColumn.Builder()
      .setHeader('E-mail')
      .setField('email')
      .setType('text')
      .setCondition('contains')
      .build(),
    new TableColumn.Builder()
      .setHeader('Glampoints')
      .setField('points')
      .setType('formattedNumber')
      .build(),
    new TableColumn.Builder()
      .setHeader('Status')
      .setField('status')
      .setType('text')
      .setCondition('equals')
      .setDisplayFunction((r: MarketingGlampointsCreditRow) =>
        r.status === 'SUCCESS'
          ? 'Creditado'
          : r.status === 'PENDING'
            ? 'Pendente'
            : 'Falha'
      )
      .build(),
    new TableColumn.Builder()
      .setHeader('Creditado por')
      .setField('createdBy')
      .setType('text')
      .setCondition('contains')
      .build()
  ];

  dropdownFilters = {
    status: [
      { label: 'Todos', value: '' },
      { label: 'Creditado', value: 'SUCCESS' },
      { label: 'Pendente', value: 'PENDING' },
      { label: 'Falha', value: 'FAILED' }
    ]
  };

  async ngOnInit(): Promise<void> {
    this.title.setTitle('Marketing - Histórico da Ação');
    const id = this.route.snapshot.paramMap.get('actionId');
    if (id) {
      this.actionId = Number(id);
      this.fixedFilters = [
        {
          field: 'actionId',
          value: String(this.actionId),
          condition: 'equals',
          fieldType: 'number'
        }
      ];
      await this.loadAction();
    }
  }

  async loadAction(): Promise<void> {
    LoaderService.showLoader();
    try {
      const action = await lastValueFrom(this.marketingService.getAction(this.actionId!));
      this.actionName = action.name;
      this.title.setTitle(`Marketing - Histórico: ${action.name}`);
    } catch (error) {
      AppDialogService.showErrorDialog(error);
    } finally {
      LoaderService.showLoader(false);
    }
  }

  async findPage(
    request: PageableRequest,
    service: unknown
  ): Promise<PageContent<MarketingGlampointsCreditRow>> {
    return lastValueFrom(
      (service as MarketingGlampointsService)
        .findHistory(request)
        .pipe(
          map((data) => data.result as PageContent<MarketingGlampointsCreditRow>)
        )
    );
  }
}
